<mat-form-field
  *ngIf="formControl"
  class="h-full w-full grow basis-0"
  floatLabel="always"
>
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [formControl]="formControl"
    disableRipple
    [placeholder]="placeholder ?? 'Kérlek válassz'"
    (valueChange)="onChange($event)"
    (blur)="onTouched()"
  >
    <mat-option
      *ngFor="let option of options; trackBy: trackByValue"
      [value]="option.key"
      >{{ option.value }}</mat-option
    >
  </mat-select>
</mat-form-field>
